import(/* webpackMode: "eager" */ "/app/.yarn/__virtual__/next-virtual-e29b8b924f/0/cache/next-npm-14.2.25-cd023f1b24-fa0cd12ba7.zip/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ClubSchedule"] */ "/app/webapp/app/pwa/(main-layout)/components/ClubSchedule.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClubTable"] */ "/app/webapp/app/pwa/(main-layout)/components/ClubTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InstallBannerDisplay"] */ "/app/webapp/app/pwa/(main-layout)/components/InstallBannerDisplay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OvNewsElement"] */ "/app/webapp/app/pwa/(main-layout)/components/OvNewsElement.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SocialMediaElement"] */ "/app/webapp/app/pwa/(main-layout)/components/SocialMediaElement.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserInquiryButton"] */ "/app/webapp/app/pwa/(main-layout)/team/[teamId]/(simple-layout)/player/[playerId]/components/UserInquiryButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/webapp/app/pwa/components/Button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/webapp/app/pwa/components/Image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default","NavMainDropdown"] */ "/app/webapp/app/pwa/components/layout/NavMainLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/webapp/app/pwa/components/layout/NavSecondaryLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavToggle"] */ "/app/webapp/app/pwa/components/layout/NavToggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsElement"] */ "/app/webapp/app/pwa/components/news/NewsElement.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserModalDisplay"] */ "/app/webapp/app/pwa/components/UserDisplay/UserModalDisplay.tsx");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/branding/logo.svg");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/bar-chart-horizontal.svg");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/calendar.svg");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/chevron-right.svg");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/default_team_logo.png");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/grid.svg");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/news.svg");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/plus.svg");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/push.svg");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/team.svg");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/tippspiel.svg");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/user.svg");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/users.svg");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/user/no-user.svg");
